import React from "react";

import Card from "../ui/Card";
import Stack from "../layout/Stack";

function KpiCard({
  title,
  value,
  subtitle = "",
}) {
  return (
    <Card width="full">
      <Stack align="center">
        <div style={{ fontSize: "0.85rem", opacity: 0.7, textAlign: "center" }}>
          {title}
        </div>

        <div style={{ fontSize: "1.8rem", fontWeight: 700, textAlign: "center" }}>
          {value}
        </div>

        {subtitle && (
          <div style={{ fontSize: "0.8rem", opacity: 0.65, textAlign: "center" }}>
            {subtitle}
          </div>
        )}
      </Stack>
    </Card>
  );
}

export default KpiCard;